export const urls = {
    merchantPortalGuide: 'https://dnapayments.com/our-services/merchant-portal',
    domainAssociationFile:
        'https://cdn.dnapayments.com/files/payment-methods/apple-pay/apple-developer-merchantid-domain-association',
    astropayReturn: window.location.origin + '/close-return.html',
    cashAdvance:
        'https://dnapayments.com/our-services/cash-advance?utm_source=DNA&utm_medium=MP&utm_campaign=Banner',
    faq: 'https://dnapayments.com/faq',
    guides: 'https://dnapayments.com/support/guides',
    paymentStatusesGuide:
        'https://www.dnapayments.com/blog/understanding-your-merchant-portal-payment-statuses',
    termsUse: 'https://dnapayments.com/page/terms-use',
    privacyPolicy: 'https://dnapayments.com/page/privacy-policy',
    cookiePolicy: 'https://dnapayments.com/page/cookie-policy',
    ecospendReturn: `https://${_IS_PROD_ ? '' : 'test-'}portal.dnapayments.com/ecospend-return`,
    supportFormUrl: 'https://dnapayments.com/online-quote#2',
    salesQuotationFormUrl: 'https://dnapayments.com/online-quote'
}
